module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-400-latin4.db81921.woff2";